import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Form
 */
export class SpecsFormValueObject extends ValueObject {
  /**
   * @param {Object}  deps
   * @param {Boolean} deps.disabled
   * @param {Boolean} deps.hidden
   * @param {Array}   deps.datalist
   */

  getDatalist() {
    return this._datalist
  }
}
